import { wishlistActions } from "../actions/wishlists";

const initialState = Object.freeze({
  wishlists: [],
  hasNextPage: false,
  error: null,
});

const wishlists = (state = initialState, action) => {
  switch (action.type) {
    case wishlistActions.ADD_NEW_WISHLIST: {
      return {
        ...state,
        wishlists: [
          ...state?.wishlists,
          { ...action?.payload?.newWishlist, items: [] },
        ],
      };
    }
    case wishlistActions.FETCH_WISHLISTS_SUCCESS: {
      const { wishlists, hasNextPage } = action.payload;
      return {
        ...state,
        wishlists,
        hasNextPage,
      };
    }
    case wishlistActions.FETCH_WISHLISTS_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
      };
    }
    case wishlistActions.ADD_TO_WISHLIST: {
      const { wishlistId, sku, productId, color, size, styleOption, type } =
        action.payload;
      const { wishlists: currentWishlists } = state;
      // avoiding mutation of state
      const wishlists = Array.from(currentWishlists);
      const addedIndex = wishlists?.findIndex((wishlist) =>
        wishlistId === "default"
          ? wishlist.default
          : wishlist?.id === wishlistId
      );

      if (addedIndex > -1) {
        wishlists[addedIndex].items = [
          ...wishlists[addedIndex]?.items,
          { type, sku, productId, color, size, styleOption },
        ];
      }

      return {
        ...state,
        wishlists,
      };
    }
    case wishlistActions.REMOVE_FROM_WISHLIST: {
      const { wishlistId, id } = action.payload;
      const { wishlists: currentWishlists } = state;
      const wishlists = Array.from(currentWishlists);

      const removed = wishlists?.find(
        (wishlist) => wishlist?.id === wishlistId
      );
      const index = removed?.items?.findIndex((item) =>
        item?.sku ? item?.sku === id : item?.styleOption === id
      );

      if (index > -1) {
        removed?.items?.splice(index, 1);
      }

      return {
        ...state,
        wishlists,
      };
    }
    default:
      return state;
  }
};

export default wishlists;
